import React from 'react'

import { OptionsMenu } from '../data-card/data-card-parts'

export default ({
  comment,
  user,
  onPin,
  onUnpin,
  unpinnable
}) => (
  <div className='comment-item data-card'>
    <p className='user-name'>
      {user.name}
      {' • '}
      <span className='timestamp'>
        {comment.createdAt.format('h:mm A, MM-DD-YYYY')}
      </span>
    </p>

    <p>{comment.body}</p>

    {getOptions({ unpinnable, comment, onPin, onUnpin })}
  </div>
)

function getOptions ({ unpinnable, comment, onPin, onUnpin }) {
  if (unpinnable) return

  let name = comment.pinned ? 'Unpin' : 'Pin'
  let action = comment.pinned ? onUnpin : onPin

  return (
    <OptionsMenu optionItems={[{ name, action }]} />
  )
}



// WEBPACK FOOTER //
// ./src/components/comments/comment-item.js